import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
} from "react-admin";
import { parse } from "query-string";
import OrgSelector from '../../components/OrgSelector';
import cameraTypes from "../../defaults/CameraTypes";

const CameraCreate = (props) => {
  const { organization_id } = parse(props.location.search);

  return (
    <Create {...props}>
      <SimpleForm>
        <OrgSelector
          fullWidth
          source="org_id"
          org_id={organization_id}
          locked={organization_id}
          required
        />
        <TextInput fullWidth label="Name" source="name" validate={[required()]} />
        <TextInput fullWidth label="Description" source="description"  />
        <TextInput fullWidth label="Camera ID" source="camera_id" validate={[required()]} />
        <SelectInput fullWidth label="Camera Type" source="camera_type" validate={[required()]} choices={cameraTypes} />
      </SimpleForm>
    </Create>
  );
};

export default CameraCreate;
